import I3302209250000001 from '@/assets/logosSenate/3-30220925000000-1.png';
import I33022092500000010 from '@/assets/logosSenate/3-30220925000000-10.png';
import I33022092500000011 from '@/assets/logosSenate/3-30220925000000-11.png';
import I33022092500000012 from '@/assets/logosSenate/3-30220925000000-12.png';
import I33022092500000014 from '@/assets/logosSenate/3-30220925000000-14.png';
import I33022092500000015 from '@/assets/logosSenate/3-30220925000000-15.png';
import I33022092500000016 from '@/assets/logosSenate/3-30220925000000-16.png';
import I33022092500000017 from '@/assets/logosSenate/3-30220925000000-17.png';
import I33022092500000018 from '@/assets/logosSenate/3-30220925000000-18.png';
import I33022092500000019 from '@/assets/logosSenate/3-30220925000000-19.png';
import I3302209250000002 from '@/assets/logosSenate/3-30220925000000-2.png';
import I33022092500000020 from '@/assets/logosSenate/3-30220925000000-20.png';
import I33022092500000021 from '@/assets/logosSenate/3-30220925000000-21.png';
import I33022092500000022 from '@/assets/logosSenate/3-30220925000000-22.png';
import I33022092500000026 from '@/assets/logosSenate/3-30220925000000-26.png';
import I33022092500000027 from '@/assets/logosSenate/3-30220925000000-27.png';
import I33022092500000028 from '@/assets/logosSenate/3-30220925000000-28.png';
import I3302209250000003 from '@/assets/logosSenate/3-30220925000000-3.png';
import I3302209250000004 from '@/assets/logosSenate/3-30220925000000-4.png';
import I3302209250000005 from '@/assets/logosSenate/3-30220925000000-5.png';
import I3302209250000006 from '@/assets/logosSenate/3-30220925000000-6.png';
import I3302209250000007 from '@/assets/logosSenate/3-30220925000000-7.png';

const logos = {
  I3302209250000001,
  I33022092500000010,
  I33022092500000011,
  I33022092500000012,
  I33022092500000014,
  I33022092500000015,
  I33022092500000016,
  I33022092500000017,
  I33022092500000018,
  I33022092500000019,
  I3302209250000002,
  I33022092500000020,
  I33022092500000021,
  I33022092500000022,
  I33022092500000026,
  I33022092500000027,
  I33022092500000028,
  I3302209250000003,
  I3302209250000004,
  I3302209250000005,
  I3302209250000006,
  I3302209250000007,
};

export const getSenateLogo = (fileName: string) => {
  const logoCode = `I${fileName
    .split('.')[0]
    .replaceAll('-', '')}` as keyof typeof logos;

  return logos[logoCode];
};
